import React, { forwardRef } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import HighchartsMore from 'highcharts/highcharts-more';
import HighchartsTreeMap from 'highcharts/modules/treemap';
import HighchartsSolidGauge from 'highcharts/modules/solid-gauge';
import HighchartsAccessibility from 'highcharts/modules/accessibility';
import HighchartsBoost from 'highcharts/modules/boost';
import { RefObjectForHighchartsReact } from './Chart.types';

HighchartsMore(Highcharts);
HighchartsTreeMap(Highcharts);
HighchartsBoost(Highcharts);
HighchartsSolidGauge(Highcharts);
HighchartsAccessibility(Highcharts);

Highcharts.setOptions({
  lang: {
    decimalPoint: '.',
    thousandsSep: ',',
  },
});

// Outer div required after upgrading to Highcharts v11 — see issue #21510.
// https://github.com/highcharts/highcharts/issues/21510
export const Chart = forwardRef<RefObjectForHighchartsReact, HighchartsReact.Props>(
  (props, ref) => (
    <div style={{ width: '100%', height: '100%' }}>
      <HighchartsReact
        ref={ref}
        highcharts={Highcharts}
        {...props}
        containerProps={{
          ...(props.containerProps || {}),
          style: {
            width: '100%',
            height: '100%',
            display: 'block',
            ...(props.containerProps?.style || {}),
          },
        }}
      />
    </div>
  ),
);
